import React, { memo } from 'react';
import './DonutChart.scss';

export const CustomToolTip = memo(({ active, payload }) => {
    if (!active || !payload?.length) {
        return null;
    }
    const total = payload.reduce((sum, entry) => sum + entry.value, 0);
    const { name, value, payload: dataEntry } = payload[0];
    const percent = total === 0 ? 0 : ((value / total) * 100).toFixed(1);

    return (
        <div className="donut-tooltip">
            <div className="donut-tooltip__row">
                <span className="donut-tooltip__color" style={{ backgroundColor: dataEntry.color }} />
                <span>{name}</span>
            </div>
            <div className="donut-tooltip__value">
                {value} ({percent}%)
            </div>
        </div>
    );
});
